import axios from "axios";
import { CharacterPreset } from "../models/CharacterPreset";
export class MetadataService {
  static async GetCharacterPresets(): Promise<CharacterPreset[]> {
    try {
      const { data, status } = await axios.get<CharacterPreset[]>(
        "/presets/presets.json"
      );
      return status === 200 && data ? data : [];
    } catch (err) {
      console.log(err);
      return [];
    }
  }
}
